import { Component, OnInit } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { FooterComponent } from './layouts/footer/footer.component';
import { NavbarComponent } from './layouts/navbar/navbar.component';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, FooterComponent, NavbarComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'tnd-frontend';
  isAdminRoute = false;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.isAdminRoute = this.anKhung(event.url);
        // Scroll to top khi navigate
        window.scrollTo(0, 0);
      });
    
    // Check initial route
    this.isAdminRoute = this.anKhung(this.router.url);
  }

  /** Ẩn navbar/footer: trang admin và trang xem PDF ở tab riêng (viewer chiếm toàn màn hình). */
  private anKhung(url: string): boolean {
    return url.startsWith('/admin') || url.startsWith('/xem-ban-pdf');
  }
}
